export const Countries = [
	{
		short: 'hun',
		long: 'Magyar',
	},
];
